<template>
  <div>
    <div class="box">
      <div class="row top-buffer">
        <h2 class="column-name col-sm-5">Main Category<br/><span class="price"><del>$0.50</del> FREE</span></h2>
        <multiselect class="col-sm-6" v-model="category_value" :options="category_options" track-by="id" label="name" :searchable="true" :show-labels="false" placeholder="Choose a Main Category" @select="populateSubCategories">
        </multiselect>
      </div>
      <div class="row top-buffer">
        <h2 class="col-sm-5">Sub Category<br/><span class="price"><del>$0.50</del> FREE</span></h2>
        <multiselect class="col-sm-6" v-model="subcategory_value" :options="subcategory_options" track-by="id" label="name" :searchable="true" :show-labels="false" placeholder="Choose a Sub Category" @select="selectSubCategory">
        </multiselect>
      </div>
      <div class="row top-buffer">
        <h2 class="col-sm-5">Keyword Search<br/><span class="price">$1.50</span></h2>
        <div class="col-sm-6 input-box">
          <input type="text" placeholder="Enter Keyword" class="form-control input-lg" />
        </div>
        <!-- <input class="col-sm-6" type="text" /> -->
      </div>
      <div class="row top-buffer">
        <h2 class="col-sm-5">Price Filter<br/><span class="price">$1.50</span></h2>
        <div class="col-sm-6 input-box">
          <input class="half-input left form-control input-lg" type="number" placeholder="Min Price" />
          <input class="half-input right form-control input-lg" type="number" placeholder="Max Price" />
        </div>
      </div>
    </div>
    <div style="text-align:right;margin-top:2em;">
      <h2 style="margin-bottom:1em;">Total: 0.00</h2>
      <button style="background:transparent;">Buy Premium Flat Rate Plan</button>
      <button @click="addSearch">Activate Search</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'SearchBox',
  components: {
    Multiselect
  },
  data () {
    return {
      category_id: '',
      subcategory_id: '',
      category_value: '',
      category_options: [],
      subcategory_value: '',
      subcategory_options: []
    }
  },
  methods: {
    closeEvent: function (e) {
      const el = this.$refs.customSelectWrapper
      const target = e.target
      if (el && el !== target && !el.contains(target)) {
        this.selectIsOpen = false
      }
    },
    openToggle: function () {
      // window.addEventListener('click', this.closeSelect)
      this.selectIsOpen = !this.selectIsOpen
    },
    getCategories () {
      this.$store.dispatch('getCategories')
        .then(() => {
          this.category_options = this.$store.getters.categories.map(cat => ({ id: cat.id, name: cat.name }))
        })
        .catch(err => console.log(err))
    },
    addSearch () {
      const data = {
        category_id: this.category_id,
        subcategory_id: this.subcategory_id
      }

      this.$store.dispatch('addSearch', data)
        .then(() => { console.log('success') })
        .catch(err => console.log(err.response.data.message))
    },
    populateSubCategories (selectedOption, id) {
      this.category_id = selectedOption.id
      const subcategories = this.$store.getters.categories.find(cat => cat.id === selectedOption.id).sub_categories
      this.subcategory_options = subcategories.map(cat => ({ id: cat.id, name: cat.name }))
    },
    selectSubCategory (selectedOption, id) {
      this.subcategory_id = selectedOption.id
    }
  },
  created () {
    document.addEventListener('click', this.closeEvent)
    this.getCategories()
  },
  events: {
    closeSelect: function () {
      if (this.selectIsOpen) {
        this.selectIsOpen = false
        window.removeEventListener('click', this.closeSelect)
      }
    }
  }
}

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.addEventListener('click', vnode.context.stopProp)
    document.body.addEventListener('click', vnode.context.closeEvent)
  },
  stopProp (event) {
    event.stopPropagation()
  }
})
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
  @import '../assets/styles/search_box.scss'
</style>
